import {RISK_RUBRIC} from './AssessmentScoring.comp';

/*
 * The group heading a risk sits under, named the same on every dashboard
 * (LA-ND, PD, SND, SD-03Nov-01).
 *
 * Each dashboard's cards name the risk families their own way — "Conduct",
 * "CONDUCT RISK", "AI-related" — so the same risk sat under a different heading
 * on each dashboard. The heading is taken instead from the scoring rubric
 * (RISK_RUBRIC: Headline, Conduct Risk, Content Risk, Contact Risk, Contract &
 * Data Risk, Wellbeing & Screen Use Risk), looked up by the risk's name. A risk
 * the rubric does not know keeps the family its card sent.
 */
const GROUP_BY_RISK = new Map(RISK_RUBRIC.map((r) => [r.indicator.toLowerCase(), r.category]));

export const riskGroupLabel = (riskName, dataFamily = '') => {
    const canonical = GROUP_BY_RISK.get(String(riskName || '').trim().toLowerCase());
    return String(canonical || dataFamily || '').trim().toUpperCase();
};
